import { IS_RESUME_FLOW } from 'app-constants'
import React, { createContext, useState } from 'react'
export interface ResumeFlowContextProps {
  isResumeFlow: boolean
  setIsResumeFlow: React.Dispatch<React.SetStateAction<boolean>>
}

export const ResumeFlowContext = createContext<ResumeFlowContextProps | null>(null)

export const ResumeFlowProvider = ({ children }: { children: React.ReactNode }) => {
  const [isResumeFlow, setIsResumeFlow] = useState(
    window.sessionStorage.getItem(IS_RESUME_FLOW) === 'true',
  )

  return (
    <ResumeFlowContext.Provider
      value={{
        isResumeFlow,
        setIsResumeFlow,
      }}
    >
      {children}
    </ResumeFlowContext.Provider>
  )
}
